"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getExperimentVariant = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _constants = require("./constants");
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      (0, _defineProperty2["default"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
var VARIANT_KEY_BY_SELECTOR = Object.entries(_constants.VARIANT_SELECTOR_BY_KEY).reduce(function (prevVariantKeyByVariantSelector, _ref) {
  var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
    variantKey = _ref2[0],
    variantSelector = _ref2[1];
  return _objectSpread(_objectSpread({}, prevVariantKeyByVariantSelector), {}, (0, _defineProperty2["default"])({}, variantSelector, variantKey));
}, {});
var defaultMatchByVariantSelector = Object.keys(VARIANT_KEY_BY_SELECTOR).reduce(function (prevVariantSelector, variantSelector) {
  return _objectSpread(_objectSpread({}, prevVariantSelector), {}, (0, _defineProperty2["default"])({}, variantSelector, false));
}, {});
var getExperimentVariant = exports.getExperimentVariant = function getExperimentVariant(variant) {
  var variantMap = _objectSpread({}, defaultMatchByVariantSelector);
  if (variant in _constants.VARIANT_SELECTOR_BY_KEY) {
    variantMap[_constants.VARIANT_SELECTOR_BY_KEY[variant]] = true;
  }
  return variantMap;
};